import CompanyChallenge from "./containers"

export default CompanyChallenge
